import { render, staticRenderFns } from "./GroupEdit.vue?vue&type=template&id=25363d89&scoped=true&"
import script from "./GroupEdit.vue?vue&type=script&lang=js&"
export * from "./GroupEdit.vue?vue&type=script&lang=js&"
import style0 from "./GroupEdit.vue?vue&type=style&index=0&id=25363d89&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25363d89",
  null
  
)

export default component.exports